import React from "react";

const Card = ({
  children,
  className = "",
  padding = "default",
  shadow = "default",
  hover = false,
  onClick,
}) => {
  const paddingStyles = {
    none: "p-0",
    sm: "p-3",
    default: "p-4",
    lg: "p-6",
  };

  const shadowStyles = {
    none: "",
    sm: "shadow-sm",
    default: "shadow-md",
    lg: "shadow-lg",
  };

  const hoverStyles = hover
    ? "hover:shadow-xl transition-shadow duration-200 cursor-pointer"
    : "";

  return (
    <div
      onClick={onClick}
      className={`
        rounded-lg border border-accent-200 bg-white
        ${paddingStyles[padding]}
        ${shadowStyles[shadow]}
        ${hoverStyles}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default Card;
